import React from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { a11yProps, TabPanel } from '../../../../components/TabsHelper'
import LanguageStrings from '../../../../i18n/locales'
import ActiveKeyMappings from './ActiveKeyMappings'
import InactiveKeyMappings from './InactiveKeyMappings'
import { useSelector } from 'react-redux'
import { type RootState } from '../../../../store'

const KeyTypeMappingsStrings = LanguageStrings().HSMConfiguration.MainComponent

const KeyTypeMappings = (): JSX.Element => {
  const sharedFontStack = 'inherit'
  const subTabFontSize = '14px'
  const activeStyle = { fontSize: subTabFontSize, color: '#F0F0F0', fontWeight: 500, fontFamily: sharedFontStack, textTransform: 'none' }
  const inActiveStyle = { fontSize: subTabFontSize, color: '#A0A0A0', fontWeight: 500, fontFamily: sharedFontStack, textTransform: 'none' }
  const initialSubtab = sessionStorage.getItem('keyTypeMappingsSubtab')
  const [currTab, setCurrTab] = React.useState(initialSubtab === '1' ? 1 : 0)
  const activeUnfilteredTotal = useSelector((state: RootState) => state.keyTypeMappingsList.data?.total_count ?? 0)
  const inactiveUnfilteredTotal = useSelector((state: RootState) => state.inactiveKeyTypeMappingsList.data?.total_count ?? 0)
  const filteredSlice = useSelector((state: RootState) => state.filterActiveKeyTypeMappingsList.data)
  const filteredTotal = filteredSlice?.total_count ?? null
  const hasFilteredResponse = filteredSlice !== null
  const isFilteredActive = currTab === 0 && hasFilteredResponse
  const isFilteredInactive = currTab === 1 && hasFilteredResponse
  const activeDisplayTotal = isFilteredActive && filteredTotal !== null ? filteredTotal : activeUnfilteredTotal
  const inactiveDisplayTotal = isFilteredInactive && filteredTotal !== null ? filteredTotal : inactiveUnfilteredTotal
  const displayTotal = currTab === 0 ? activeDisplayTotal : inactiveDisplayTotal

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setCurrTab(newValue)
    sessionStorage.setItem('keyTypeMappingsSubtab', String(newValue))
  }

  const getStyle = (index: number): any => {
    if (index === currTab) return activeStyle
    return inActiveStyle
  }

  return (
    <div>
      <Box sx={{ width: '100%' }}>
        {/* Tabs first */}
        <Box sx={{ paddingLeft: 0, marginBottom: '8px', borderBottom: '0px solid #404040' }}>
          <Tabs
            value={currTab}
            onChange={handleChange}
            aria-label='key mappings tabs'
            TabIndicatorProps={{ style: { height: '2px', borderRadius: '1px' } }}
          >
            <Tab style={getStyle(0)} label={KeyTypeMappingsStrings.ActiveKeyMappings} {...a11yProps(0)} />
            <Tab style={getStyle(1)} label={KeyTypeMappingsStrings.InactiveKeyMappings} {...a11yProps(1)} />
          </Tabs>
        </Box>
        {/* Heading below tabs (no separating line) */}
        <div className='configurations-table-heading' style={{ margin: '0 0 0px 0' }}>
          <h5 data-testid='group-name' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>{KeyTypeMappingsStrings.KeyTypeMappings}</span>
            <span className='config-list-box'>
              {displayTotal} {KeyTypeMappingsStrings.KeyTypeMappings}
            </span>
          </h5>
        </div>
        <TabPanel value={currTab} index={0}>
          <ActiveKeyMappings />
        </TabPanel>
        <TabPanel value={currTab} index={1}>
          <InactiveKeyMappings />
        </TabPanel>
      </Box>
    </div>
  )
}

export default KeyTypeMappings
